module.exports = __webpack_public_path__ + "static/media/title-form.745fa8b5.png";